import { useState, useEffect } from "react";

export function useAsyncResource<T, A extends unknown[]>(
  asyncFunction: (...args: A) => Promise<T>,
  ...args: A
): T | null {
  const [data, setData] = useState<T | null>(null);

  useEffect(() => {
    let isCancelled = false;

    async function fetchData() {
      try {
        const result = await asyncFunction(...args);
        if (!isCancelled) {
          setData(result);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchData();

    return () => {
      // eslint-disable-next-line fp/no-mutation
      isCancelled = true;
    };
  }, [asyncFunction, ...args]);

  return data;
}
